import {useDispatch, useSelector} from "react-redux";
import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row} from "reactstrap";
import BackInStockTable from "../../backInStock/content/backInStockTable";
import sellerReducer from "../store";
import withReducer from "../../../store/withReducer";
import {
    approveRequest,
    geSellerProductList,
    getSellerProductList,
    getSellers,
    retrieveProducts,
    setSellers
} from "../store/sellerProductListSlice";
import moment from "moment/moment";
import PreLoader from "../../../share-components/ui/preLoader";
import {toast} from "react-toastify";
import AsyncSelect from "react-select/async";
import {mapSearchAutoSuggestion} from "../../../utils/mapper";
import {sellerBrandSuggestionApi} from "../../../services/manage-product/productService";
import ButtonLoader from "../../../share-components/ui/buttonLoader";
import Select from "react-select";

const dataMenu = [
    {
        type: 0,
        text: 'Product',
        link: '/product'
    },
    {
        type: 1,
        text: 'Sync Products',
        link: ''
    },
];

// status label mapping for UI
const formatStatusLabel = (status) => {
    const v = (status || '').toString().toLowerCase();
    if (v === 'pending') return 'Pending';
    if (v === 'send') return 'Sent';
    if (v === 'publish') return 'Published';
    return status;
};

// disable row selection if already published
const isRowDisabled = (row) => {
    const v = (row?.status || '').toString().toLowerCase();
    return v === 'publish' || v === 'published' || v === 'Publish'.toLowerCase();
};

const ProductList = () => {
    const dispatch = useDispatch();
    const [loading, isSetLoading] = useState(true);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [page, setPage] = useState(0);

    const sellerProductListState = useSelector(({seller}) => seller.sellerProductList);
    const sellerProductList = useSelector(geSellerProductList);

    const [orderCheckBoxData, setOrderCheckBoxData] = useState({idArray: []});
    const [isChecked, setIsChecked] = useState(null);

    const [seller, setSeller] = useState(null);
    const [itemIdArray, setItemIdArray] = useState([]);
    const [removed, setRemoved] = useState(false);

    const [pageSize, setPageSize] = useState(10);

    const TodayDate = new Date();
    const sevenDays = new Date().setDate(TodayDate.getDate() - 30);
    const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
    const [startDate, endDate] = dateRange;

    const [timer, setTimer] = useState(null);
    const [name, setName] = useState(null);

    const userState = useSelector(({authReducer}) => authReducer.data);

    const [brandsVal, setBrandsVal] = useState(null);

    const [statusFilter, setStatusFilter] = useState(null); // {label,value} -> value: pending/send/publish
    const [sellerShopifyStatusFilter, setSellerShopifyStatusFilter] = useState(null); // ACTIVE/DRAFT/ARCHIVED

    const pageSizeOptions = [10, 20, 30, 50, 100];

    let idArray = [];
    const handleChange = (state) => {
        if (state.selectedCount > 0) {
            setIsChecked(true);
            state.selectedRows.map((item, i) => {
                idArray.push(item.id);
                setItemIdArray(idArray);
                setOrderCheckBoxData(prevState => ({
                    idArray: [...prevState.idArray, ...idArray],
                }));
            });
        } else {
            setIsChecked(false);
        }
    };

    const getData = () => {
        const data = {
            page: page,
            seller_id: seller,
            name,
            brand: brandsVal ? brandsVal.label : '',
            status_id: statusFilter ? statusFilter.value : null,
            seller_shopify_status: sellerShopifyStatusFilter ? sellerShopifyStatusFilter.value : null,
            pageSize: pageSize,
            start_date: moment(startDate).format('YYYY-MM-DD'),
            end_date: moment(endDate).format('YYYY-MM-DD'),
        };

        dispatch(getSellerProductList(data)).then(res => {
            if (!res.error) {
                isSetLoading(false);
            }
        });
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, page, pageSize, seller, name, brandsVal, statusFilter, sellerShopifyStatusFilter]);

    const loadSellers = () => {
        dispatch(getSellers()).then(res => {
            dispatch(setSellers(res.payload.response));
        });
    };

    useEffect(() => {
        loadSellers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    // Backend-formatted string, printed as-is (project convention: no client-side date conversion).
    const selectedSeller = Array.isArray(sellerProductListState.sellerList)
        ? sellerProductListState.sellerList.find(s => s.id === seller)
        : null;

    const pageChange = (e) => {
        setPage(e);
    };

    const onPageSizeChange = (e) => {
        setPageSize(e);
        setPage(0);
    };

    const toggleRowSelected = (id) => {
        // Code here
    };

    const customStyles = {
        control: base => ({
            ...base,
            minHeight: 50,
        })
    };

    const typePromiseOption = (inputValue, seller) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue,
                seller_id: seller
            };
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerBrandSuggestionApi(data)));
            });
        });

    const statusOptions = [
        {label: 'Pending', value: 1},
        {label: 'Sent', value: 2},
        {label: 'Published', value: 3},
    ];

    const sellerShopifyStatusOptions = [
        {label: 'ACTIVE', value: 'ACTIVE'},
        {label: 'DRAFT', value: 'DRAFT'},
        {label: 'ARCHIVED', value: 'ARCHIVED'},
    ];

    const tableColumns = [
        {
            name: 'Product',
            sortable: true,
            center: false,
            minWidth: '40%',
            selector: params => (
                <div className="p-1 d-flex align-items-center">
                    <img width={30} className="img-fluid" src={params.image} alt={params.id} />

                    <span
                        className="ml-2"
                        style={{
                        flex: 1,
                        minWidth: 0,           // important for ellipsis inside flex
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        }}
                        title={params.title}     // optional hover full title
                    >
                        {params.title}
                    </span>
                    </div>
            )
        },
        {
            name: 'Product Type',
            selector: row => row.product_type,
            sortable: true,
            right: false,
        },
        {
            name: 'Available Quantity',
            selector: row => row.inventory_qty,
            sortable: true,
            right: false,
        },
        {
            name: 'Seller Shopify Status',
            selector: row => row.seller_shopify_status,
            sortable: true,
            right: false,
        },
        {
            name: 'Status',
            selector: row => row.status,
            cell: row => <span>{formatStatusLabel(row.status)}</span>,
            sortable: true,
            right: true,
        },
    ];

    return (
        <Fragment>
            {loading ? (
                <>
                    <PreLoader/>
                </>
            ) : (
                <>
                    <Breadcrumb data={dataMenu} title="Sync Products"/>
                    <Container fluid={true}>
                        <div className="product-grid">
                            <div className="feature-products">
                                <Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <Row>
                                                    {userState.user.role.name !== "Seller" ? (
                                                        <Col sm={4}>
                                                            <FormGroup>
                                                                <Label className="form-label">Seller</Label>
                                                                <Select
                                                                    placeholder={<div>Seller</div>}
                                                                    getOptionLabel={(option) => option.name}
                                                                    getOptionValue={(option) => option.id}
                                                                    isClearable
                                                                    styles={customStyles}
                                                                    options={sellerProductListState.sellerList}
                                                                    onChange={(e) => {
                                                                        setSeller(e ? e.id : null);
                                                                        setBrandsVal(null);

                                                                        // reset new filters too
                                                                        setStatusFilter(null);
                                                                        setSellerShopifyStatusFilter(null);

                                                                        setPage(0);
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    ) : null}

                                                    <Col sm={userState.user.role.name !== "Seller" ? 4 : 8} className="d-flex align-items-end">
                                                        <div className='pb-3'>
                                                            <ButtonLoader
                                                                onClick={() => {
                                                                    if (userState.user.role.name === "Seller") {
                                                                        setButtonDisable(true);
                                                                        dispatch(retrieveProducts()).then(res => {
                                                                            if (!res.error) {
                                                                                setButtonDisable(false);
                                                                                getData();
                                                                                toast.success("List updated successfully", {
                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                });
                                                                            } else {
                                                                                setButtonDisable(false);
                                                                                toast.error("API Token is Unauthorized", {
                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                });
                                                                            }
                                                                        });
                                                                    } else {
                                                                        if (seller) {
                                                                            setButtonDisable(true);
                                                                            const formData = {seller_id: seller};
                                                                            dispatch(retrieveProducts(formData)).then(res => {
                                                                                if (!res.error) {
                                                                                    setButtonDisable(false);
                                                                                    getData();
                                                                                    loadSellers();
                                                                                    toast.success("List updated successfully", {
                                                                                        position: toast.POSITION.TOP_RIGHT,
                                                                                    });
                                                                                } else {
                                                                                    setButtonDisable(false);
                                                                                    // A 422 (e.g. partial Shopify pull) is already toasted with the server's
                                                                                    // message by src/utils/api.jsx and arrives here without a name.
                                                                                    if (res.error.name) {
                                                                                        toast.error("API Token is Unauthorized", {
                                                                                            position: toast.POSITION.TOP_RIGHT,
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        } else {
                                                                            toast.error("Add Seller First", {
                                                                                position: toast.POSITION.TOP_RIGHT,
                                                                            });
                                                                        }
                                                                    }
                                                                }}
                                                                color="success"
                                                                value="0"
                                                                className="mr-2"
                                                                type="submit"
                                                                disabled={buttonDisable}
                                                                btntext="Retrieve Products"
                                                            />
                                                            {selectedSeller ? (
                                                                <span className="text-muted">
                                                                    Last retrieved: {selectedSeller.last_retrieved_at || 'Never'}
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </Col>

                                                    <Col sm="4" className="d-flex align-items-end justify-content-end">
                                                        <div className='pb-3'>
                                                            {isChecked && (
                                                                <a
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() => {
                                                                        const finalArr = [...new Set(itemIdArray)];
                                                                        dispatch(approveRequest({id: finalArr})).then(res => {
                                                                            if (!res.error) {
                                                                                toast.success("Send Request successfully", {
                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                });

                                                                                // reset checkbox selection
                                                                                setIsChecked(false);
                                                                                setItemIdArray([]);
                                                                                setOrderCheckBoxData({idArray: []});

                                                                                // trigger table selection reset (BackInStockTable uses this prop)
                                                                                setRemoved(prev => !prev);

                                                                                // re-fetch so status updates to Sent immediately
                                                                                getData();
                                                                            }
                                                                        });
                                                                    }}
                                                                >
                                                                    Send Checked Products to Admin
                                                                </a>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm="12">
                                        <Row className="mt-2">
                                            {userState.user.role.name !== "Seller" ? (
                                                <Col sm={4}>
                                                    <FormGroup>
                                                        <Label className="form-label">Brand</Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            key={seller}
                                                            classNamePrefix="select"
                                                            isClearable={true}
                                                            defaultOptions
                                                            className="basic-single"
                                                            placeholder="Select Brand"
                                                            loadOptions={(inputValue) => {
                                                                return typePromiseOption(inputValue, seller);
                                                            }}
                                                            styles={customStyles}
                                                            menuPortalTarget={document.body}
                                                            components={{
                                                                IndicatorSeparator: () => null
                                                            }}
                                                            value={brandsVal}
                                                            onChange={(e) => {
                                                                setBrandsVal(e ? e : null);
                                                                setPage(0);
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            ) : null}

                                            <Col sm={userState.user.role.name !== "Seller" ? 4 : 6}>
                                                <FormGroup>
                                                    <Label className="form-label">Status</Label>
                                                    <Select
                                                        placeholder={<div>Status</div>}
                                                        isClearable
                                                        styles={customStyles}
                                                        options={statusOptions}
                                                        value={statusFilter}
                                                        onChange={(e) => {
                                                            setStatusFilter(e ? e : null);
                                                            setPage(0);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={userState.user.role.name !== "Seller" ? 4 : 6}>
                                                <FormGroup>
                                                    <Label className="form-label">Seller Shopify Status</Label>
                                                    <Select
                                                        placeholder={<div>Seller Shopify Status</div>}
                                                        isClearable
                                                        styles={customStyles}
                                                        options={sellerShopifyStatusOptions}
                                                        value={sellerShopifyStatusFilter}
                                                        onChange={(e) => {
                                                            setSellerShopifyStatusFilter(e ? e : null);
                                                            setPage(0);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={12}>
                                                <Form>
                                                    <FormGroup className="m-0">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                clearTimeout(timer);
                                                                const newTimer = setTimeout(() => {
                                                                    setName(e.target.value);
                                                                    setPage(0);
                                                                }, 500);
                                                                setTimer(newTimer);
                                                            }}
                                                            placeholder="Search Product"
                                                        />
                                                        <i className="fa fa-search"></i>
                                                    </FormGroup>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="mt-4" sm="12">
                                        <Card>
                                            <CardBody>
                                                <div className="table-responsive product-table">
                                                    <BackInStockTable
                                                        noAction
                                                        selectableRowDisabled={isRowDisabled}
                                                        tableColumns={tableColumns}
                                                        idArray={orderCheckBoxData}
                                                        remove={removed}
                                                        backStockData={sellerProductList}
                                                        backInRequestState={sellerProductListState}
                                                        paginationTotalRows={sellerProductListState.sellerProductListTableRow}
                                                        pageChange={pageChange}
                                                        paginationRowsPerPageOptions={pageSizeOptions}
                                                        onPageSizeChange={onPageSizeChange}
                                                        toggleRowSelected={toggleRowSelected}
                                                        handleChange={handleChange}
                                                    />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </>
            )}
        </Fragment>
    );
};

export default withReducer([{seller: sellerReducer}])(ProductList);
